import { useMemo } from 'react';
import { useMutation, MutationOptions } from 'react-query';
import ResidentService from '../../services/residentService';
import useAbortController from '../../hooks/useAbortController';

const useResidentMutation = ({
  organizationId,
  propertyId,
  options,
}: {
  organizationId: string,
  propertyId: string,
  options: MutationOptions,
}) => {
  const residentService = useMemo(() => new ResidentService(), []);
  const abortControllerOptions = useAbortController();

  return useMutation(
    ({ id, residentId, applicantId, isAdult, ...resident }) =>
      residentService.updateResident(
        organizationId,
        propertyId,
        id,
        { ...resident, applicantId, minorsResId: residentId ?? id },
        isAdult,
        abortControllerOptions,
      ),
    options,
  );
};

export default useResidentMutation;
